/**
 * @flow
 * @relayHash 53105bea8067caac6be01a4db9fe7ddf
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AccountCreateInput = {|
  name: string
|};
export type CreateAccountMutationVariables = {|
  data: AccountCreateInput
|};
export type CreateAccountMutationResponse = {|
  +createAccount: {|
    +id: string
  |}
|};
export type CreateAccountMutation = {|
  variables: CreateAccountMutationVariables,
  response: CreateAccountMutationResponse,
|};
*/


/*
mutation CreateAccountMutation(
  $data: AccountCreateInput!
) {
  createAccount(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "AccountCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createAccount",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "AccountModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateAccountMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateAccountMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateAccountMutation",
    "id": null,
    "text": "mutation CreateAccountMutation(\n  $data: AccountCreateInput!\n) {\n  createAccount(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c52d4bacd6c61126fe800c3e58f8900c';
module.exports = node;
